<template>
    <div>
        <h2>Page Not Found</h2>
    </div>
</template>